<div class="card">
  <div class="card-header">
    <h5>Автоматизирани Заявки за Услуги</h5>
  </div>
  <div class="card-body">
    <ng-container *ngIf="isLoading">
      <div style="text-align: center; padding: 40px;">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Зареждане...</span>
        </div>
        <p style="margin-top: 10px;">Зареждане на данни...</p>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && serviceRequests.length === 0">
      <div style="text-align: center; padding: 40px;">
        <p class="text-muted">Няма автоматизирани заявки за показване</p>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && serviceRequests.length > 0">
      <div class="table-responsive">
        <table class="table table-hover table-striped">
          <thead>
            <tr>
              <th scope="col">Заявител</th>
              <th scope="col">ЕГН</th>
              <th scope="col">Услуга</th>
              <th scope="col">Вид срок</th>
              <th scope="col">Образец</th>
              <th scope="col">РНУ</th>
              <th scope="col">УРИ</th>
              <th scope="col">Такса</th>
              <th scope="col">Статус</th>
              <th scope="col">Дата</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let request of serviceRequests">
              <td>{{ getRequestorName(request) }}</td>
              <td>{{ request.egn }}</td>
              <td>{{ getDeliverServiceName(request) }}</td>
              <td>{{ getServiceTermType(request) }}</td>
              <td>{{ getSample(request) }}</td>
              <td>{{ getRNU(request) }}</td>
              <td>{{ getURI(request) }}</td>
              <td>
                {{ getTotalTax(request) }}
                <span *ngIf="getPaymentStatus(request) !== 'none'" [class]="getPaymentBadgeClass(request)">
                  {{ getPaymentBadgeText(request) }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(request.status)">
                  {{ getStatus(request) }}
                </span>
              </td>
              <td>{{ getDate(request) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>

